<template>
  <div class="account-user" @click="toggleDropdown" ref="profileButton">
    <vue-feather type="user"></vue-feather>
  </div>
  <ul
    class="profile-dropdown onhover-show-div"
    :class="{ active: isDropdownOpen }"
    ref="dropdownMenu"
    @click.stop
  >
    <li>
      <router-link to="/users/profile" @click="closeDropdown">
        <vue-feather type="user"></vue-feather>
        <span>Mi Perfil</span>
      </router-link>
    </li>
    <li>
      <router-link to="/users/edit" @click="closeDropdown">
        <vue-feather type="settings"></vue-feather>
        <span>Configuración</span>
      </router-link>
    </li>
    <li>
      <a @click="handleLogout" style="cursor: pointer">
        <vue-feather type="log-in"></vue-feather>
        <span>Cerrar Sesión</span>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProfileView',
  data() {
    return {
      isDropdownOpen: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser', 'isAuthenticated']),
  },
  mounted() {
    // Cerrar dropdown al hacer click fuera
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    // Limpiar event listener
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    ...mapActions('auth', ['logout']),

    toggleDropdown() {
      // En dispositivos móviles o cuando se detecta touch, usar toggle
      this.isDropdownOpen = !this.isDropdownOpen
    },

    closeDropdown() {
      this.isDropdownOpen = false
    },

    handleClickOutside(event) {
      // Cerrar dropdown si se hace click fuera del componente
      if (this.$refs.profileButton && this.$refs.dropdownMenu) {
        if (
          !this.$refs.profileButton.contains(event.target) &&
          !this.$refs.dropdownMenu.contains(event.target)
        ) {
          this.closeDropdown()
        }
      }
    },

    async handleLogout() {
      try {
        // Cerrar dropdown antes de logout
        this.closeDropdown()

        // Ejecutar logout del módulo auth
        await this.logout()

        // Redirigir al login
        this.$router.replace('/login')
      } catch (error) {
        console.error('Error al cerrar sesión:', error)
        // Aunque haya error, redirigir al login
        this.$router.replace('/login')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// Soporte para click en móviles además de hover en desktop
@media (hover: none) and (pointer: coarse) {
  // Para dispositivos táctiles (móviles/tablets)
  .onhover-dropdown {
    .onhover-show-div {
      opacity: 0;
      transform: translateY(-10px);
      visibility: hidden;
      transition: all linear 0.3s;

      &.active {
        opacity: 1;
        transform: translateY(0);
        visibility: visible;
      }
    }
  }
}

// Para pantallas pequeñas, usar click en lugar de solo hover
@media screen and (max-width: 991px) {
  .onhover-dropdown {
    .profile-dropdown.onhover-show-div {
      opacity: 0;
      transform: translateY(-10px);
      visibility: hidden;
      transition: all linear 0.3s;

      &.active {
        opacity: 1;
        transform: translateY(0);
        visibility: visible;
      }
    }

    // En móviles, desactivar el hover para evitar conflictos
    &:hover {
      .profile-dropdown.onhover-show-div:not(.active) {
        opacity: 0;
        transform: translateY(-10px);
        visibility: hidden;
      }
    }
  }
}
</style>
